import { Button } from '@/components/Button';
import { contactUs } from '@/utils';

export const Main = () => {
  return (
    <section
      className="relative w-full bg-neutral-neutral-00 px-4 py-16 sm:px-6 md:px-12 md:py-20 lg:px-20 lg:py-24"
      id="hero"
      aria-label="Hero section"
    >
      <div className="mx-auto mt-[40px] max-w-7xl">
        <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-16 xl:gap-20">
          {/* Left content */}
          <div className="order-2 lg:order-1">
            {/* Headline group */}
            <header className="mb-6 lg:mb-8">
              <h2 className="mb-2 font-headline-headline-4-font-family text-lg font-headline-headline-4-font-weight uppercase leading-tight text-neutral-neutral-70 sm:text-xl md:text-2xl lg:text-2xl">
                Transform Your Space with
              </h2>
              <h1 className="font-headline-headline-1-font-family text-4xl font-headline-headline-1-font-weight uppercase leading-none text-primary-primary-50 sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl">
                Furnitech
              </h1>
            </header>

            {/* Description with vertical line - hidden on mobile, shown on tablet+ */}
            <div className="mb-8 hidden items-start gap-6 sm:flex lg:mb-10">
              <div className="mt-1 h-16 w-0.5 flex-shrink-0 bg-neutral-neutral-70 lg:h-24"></div>
              <p className="font-body-body-2-font-family text-lg font-body-body-2-font-weight leading-relaxed text-neutral-neutral-70 md:text-xl lg:text-2xl xl:text-body-body-2-font-size">
                Furnitech brings your interior vision to life with tailored home
                designs, combining style, comfort, and love for your space.
              </p>
            </div>

            {/* Description without line for mobile */}
            <div className="mb-8 sm:hidden">
              <p className="font-body-body-2-font-family text-lg font-body-body-2-font-weight leading-relaxed text-neutral-neutral-70">
                Furnitech brings your interior vision to life with tailored home
                designs, combining style, comfort, and love for your space.
              </p>
            </div>

            {/* Call to action section */}
            <div>
              <p className="mb-6 font-body-body-2-font-family text-base font-body-body-2-font-weight leading-relaxed text-neutral-neutral-70 sm:text-lg lg:mb-8 lg:text-xl">
                Get started today — schedule a consultation and discover what
                makes <strong>Furnitech different</strong>.
              </p>
              <div className="inline-block">
                <Button title="CONTACT US" onClick={contactUs} />
              </div>
            </div>
          </div>

          {/* Right image */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img
                className="h-[280px] w-full rounded-card-lg object-cover shadow-xl sm:h-[350px] md:h-[450px] lg:h-[550px] xl:h-[600px]"
                src="hero.png"
                alt="Happy family in modern living room with stylish furniture - father and children playing on the floor while mother sits nearby, showcasing comfortable home design by Furnitech"
                loading="eager"
                decoding="async"
                width="600"
                height="600"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
